// utils/validators.ts
export const validatePhoneNumber = (phone: string): { isValid: boolean; error: string | null } => {
    if(!phone) {
        return {isValid: false, error: 'Phone number must be filled' }
    }
    const phoneRegex = /^(\+?[0-9- ]+)$/;
    const hasAdditionalPlus = phone.slice(1).includes('+');
    const trimmedPhone = phone.trim();
  
    if (!trimmedPhone) {
      return { isValid: true, error: null };
    }
  
    if (!phoneRegex.test(trimmedPhone)) {
      return { isValid: false, error: 'Phone number must contain only digits, dashes, and a single space, optionally starting with "+"' };
    }
  
    if (hasAdditionalPlus) {
      return { isValid: false, error: 'The "+" character is only allowed at the start of the phone number' };
    }
  
    if (/\s\s/.test(trimmedPhone)) {
      return { isValid: false, error: 'Multiple consecutive spaces are not allowed' };
    }
  
    return { isValid: true, error: null };
};
  
export const validateEmail = (email: string): { isValid: boolean; error: string | null } => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
        return { isValid: true, error: null };
    }

    if (!emailRegex.test(trimmedEmail)) {
        return { isValid: false, error: 'Please enter a valid email address' };
    }

    if (trimmedEmail.length > 254) {
        return { isValid: false, error: 'Email address is too long' };
    }

    const [localPart, domain] = trimmedEmail.split('@');

    if (localPart.length > 64) {
        return { isValid: false, error: 'Email local part is too long' };
    }

    if (domain.length > 253) {
        return { isValid: false, error: 'Email domain is too long' };
    }

    if (/\.\./.test(trimmedEmail)) {
        return { isValid: false, error: 'Email cannot contain consecutive dots' };
    }

    if (localPart.startsWith('.') || localPart.endsWith('.')) {
        return { isValid: false, error: 'Email local part cannot start or end with a dot' };
    }

    return { isValid: true, error: null };
};

export const validateUsername = (username: string): { isValid: boolean; error: string | null } => {
    const trimmedUsername = username.trim();

    if (!trimmedUsername) {
        return { isValid: false, error: 'Username is required' };
    }

    if (trimmedUsername.length < 3) {
        return { isValid: false, error: 'Username must be at least 3 characters' };
    }

    return { isValid: true, error: null };
};

export const validatePassword = (password: string): { isValid: boolean; error: string | null } => {
    const trimmedPassword = password.trim();

    if (!trimmedPassword) {
        return { isValid: false, error: 'Password is required' };
    }

    if (trimmedPassword.length < 6) {
        return { isValid: false, error: 'Password must be at least 6 characters' };
    }

    return { isValid: true, error: null };
};

export const validateFirstName = (firstName: string): { isValid: boolean; error: string | null } => {
    const trimmedFirstName = firstName.trim();

    if (!trimmedFirstName) {
        return { isValid: false, error: 'First name is required' };
    }

    return { isValid: true, error: null };
};

export const validateLastName = (lastName: string): { isValid: boolean; error: string | null } => {
    const trimmedLastName = lastName.trim();

    if (!trimmedLastName) {
        return { isValid: false, error: 'Last name is required' };
    }

    return { isValid: true, error: null };
};